/**
 * MA-THEME-PRESET-UX-ENHANCEMENT-079: Diagnostic LP Preview
 *
 * Amplified to make theme differences obvious at small preview scale:
 * - Thick signature divider (border_strong) — 2px, the #1 recognition signal
 * - Large surface_subtle hero area with visible tone
 * - Nested elevation card with clear border_subtle visibility test
 * - Bold text hierarchy bars (primary vs secondary clearly different)
 * - Outer border (border_subtle) wrapping entire preview
 */

export function BrandLPPreview({ theme }) {
  if (!theme?.tokens) return null;
  const t = theme.tokens;

  return (
    <div
      data-testid="brand-lp-preview"
      style={{
        backgroundColor: t.surface_base,
        borderRadius: 12,
        overflow: 'hidden',
        width: '100%',
        border: `1.5px solid ${t.border_subtle}`,
      }}
    >
      {/* Hero — large surface_subtle area to show tone clearly */}
      <div style={{ backgroundColor: t.surface_subtle, padding: '20px 16px 16px' }}>
        {/* Title — thick bar for text_primary visibility */}
        <div style={{ width: '50%', height: 10, backgroundColor: t.text_primary, borderRadius: 3, opacity: 0.9 }} />
        {/* Subtitle — text_secondary contrast test */}
        <div style={{ width: '70%', height: 7, backgroundColor: t.text_secondary, borderRadius: 3, marginTop: 7 }} />

        {/* Nested elevation card — shows surface layering + border visibility */}
        <div style={{
          backgroundColor: t.surface_elevated,
          border: `1.5px solid ${t.border_subtle}`,
          borderRadius: 8,
          padding: '9px 10px',
          marginTop: 14,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}>
          <div style={{ width: 20, height: 20, borderRadius: 6, backgroundColor: t.primary, flexShrink: 0 }} />
          <div style={{ flex: 1 }}>
            <div style={{ width: '65%', height: 5, backgroundColor: t.text_primary, borderRadius: 2, opacity: 0.75 }} />
            <div style={{ width: '45%', height: 4, backgroundColor: t.text_secondary, borderRadius: 2, marginTop: 4 }} />
          </div>
        </div>

        {/* CTA */}
        <div style={{
          width: 70, height: 26, backgroundColor: t.primary, borderRadius: 7, marginTop: 14,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <span style={{ color: t.primary_foreground, fontSize: 8, fontWeight: 600 }}>Get Started</span>
        </div>
      </div>

      {/* SIGNATURE DIVIDER — 2px border_strong, the #1 differentiator */}
      <div style={{ height: 2, backgroundColor: t.border_strong }} />

      {/* Content section — surface_base with elevated card */}
      <div style={{ padding: '12px 14px' }}>
        <div style={{
          backgroundColor: t.surface_elevated,
          border: `1.5px solid ${t.border_subtle}`,
          borderRadius: 8,
          padding: 11,
        }}>
          <div style={{ width: '55%', height: 6, backgroundColor: t.text_primary, borderRadius: 3, opacity: 0.7 }} />
          <div style={{ width: '75%', height: 5, backgroundColor: t.text_secondary, borderRadius: 3, marginTop: 6 }} />
          {/* Secondary CTA with border_strong outline — amplifies border visibility */}
          <div style={{
            width: 58, height: 20, borderRadius: 5, marginTop: 10,
            border: `1.5px solid ${t.border_strong}`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <span style={{ color: t.text_secondary, fontSize: 7, fontWeight: 500 }}>Details</span>
          </div>
        </div>
      </div>
    </div>
  );
}
